var _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomnav1Active(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_913_324",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_913_324",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADLklEQVR4nO2cPW8TQRCGF4EgTSRqQFRBEZGSHUOBFDxzEg2hwNkJsgRVqKj4KGnpCD+BCinwB6DiFwBpCBVNKhBJSiCREBIIoyMEnA/LSbx3sz6/jzSNndjeJ6/ndrTROQcAAAAAANrIZrMhUn7kg6z4wKsUeC5/rP1nQI/UGpMnSOUNqbS2VOC355sXT/f6+sA5N3FNaj7Ihx2S/5ZXWZ5o1C9AVi9J1vp1H+RbJ8n/i7/7ab4J2fuk2Wwezntwd8E7hD/OsuzIft9vIBltTA77wM/3L3mzb8tLP50dt15H0tSuZiNe+f2BJf/r27xUC3LWej1JMjHDl0n5c6+S22qtptKwXldS+CC3vPKPiJI3kh34p1e57wadbDYb8oHnYwveRfh8t+FmrDl2dHMg2r59zC/M+fOuj4eQhaIlt9VC/p6dPk/XXU7gOVe1IYQKS7asdBputid5l2/FqusnKGQ39jaEFFW7Dzd7+V1X7SFEihK+ZbiphOjRxuQwKb+wl9t5uOl70TQjZ2IMIUXV5nDT16IpyBUf+Iu1zO61t0HJpQgFuZcPDPYSJVq5lBiZmjpGKk+spVCVRXc8CdFqlEuBceVzpPLRWgZVWbT9ECLVFp3eECLVE51v9PMNv/XiqcQq/eQm9SGEihKtvESN+lgpkmuaTUU+CWn1Wa1R4OlCJVdxCKGD1S+v/MA5dyiq4D+nD0GeJbDAVmL1NOrJi1d5mMCiWilW7iam6GXrBVGilZ/MQLSWIDvwp2iiB2koIcvWsXEx5Dm0ELH5NwTrNFHJVbhQiBaIJiTa/qtOaB1iLg09Wu2F4mKoxUmBaC0nfRCtEJ30wOKQaIHoKk2GDokWiEaiBftoQuuw78eEHg3RUbBOLSHREB0V69QSEg3RUbFOLSHREB0V69QSEg3RUbFOLSHREB0V69QSEg3RUbFOLSHR9qIpgT/eQCSaIFrMhfVfogOvWy+eSiqv8tVOdLk3CGyZig782lL03QESfdv0tj4+yDtrCVR48aL5vUnHNTtVbdm86JuXTroUyJNd0/qdvI9V4gIZeN0rv8rbhXmSAQAAAAAAAAAAAFx6/AajCArNRLe2vwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnav1Active);
export default __webpack_public_path__ + "static/media/bottomnav-1-active.ab51e5c6dfd3efd59ade994491a7783a.svg";
export { ForwardRef as ReactComponent };